/**
 * This is used as the key for the locationLite cookie, i.e. `cookies.parse(document.cookie)[LOCATION_LITE_KEY]`
 */
var LOCATION_LITE_KEY = 'locationLite';
/**
 * This is the "api version" of the locationLite object cookie. It is not related to the NPM package version.
 *
 * When the structure of the cookie changes, this should be incremented, and handling for prior versions of the cookie
 * should be implemented in all locationLite packages
 */
var LOCATION_LITE_COOKIE_DATA_VERSION = 3;
/**
 * Number of milliseconds from now when the cookie will expire. Currently 1yr.
 */
var LOCATION_LITE_COOKIE_EXPIRATION_FROMNOW = 365 * 24 * 60 * 60 * 1000;

export { LOCATION_LITE_COOKIE_DATA_VERSION, LOCATION_LITE_COOKIE_EXPIRATION_FROMNOW, LOCATION_LITE_KEY };
//# sourceMappingURL=constants.esm.js.map
